/* tp.js — 9ine Life trust-page sections
   Two jobs: scroll reveal (matches the PDP hero vocabulary) and the FAQ accordion.
   Safe to load once per page; every hook is idempotent. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = root.querySelectorAll('.tp-reveal:not([data-tp-seen])');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.setAttribute('data-tp-seen', '');
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    els.forEach(function (el) {
      el.setAttribute('data-tp-seen', '');
      io.observe(el);
    });
  }

  function closePanel(head, panel) {
    panel.style.height = panel.scrollHeight + 'px';
    // force reflow so the transition has a start value
    void panel.offsetHeight;
    panel.style.height = '0px';
    head.setAttribute('aria-expanded', 'false');
  }

  function openPanel(head, panel) {
    panel.style.height = panel.scrollHeight + 'px';
    head.setAttribute('aria-expanded', 'true');
  }

  function initFaq(root) {
    root.querySelectorAll('.tp-faq__head:not([data-tp-bound])').forEach(function (head) {
      head.setAttribute('data-tp-bound', '');

      var panel = document.getElementById(head.getAttribute('aria-controls'));
      if (!panel) return;

      // an item that starts open (theme-editor default) needs its height set
      if (head.getAttribute('aria-expanded') === 'true') {
        panel.style.height = 'auto';
      }

      panel.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'height') return;
        if (head.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
      });

      head.addEventListener('click', function () {
        var open = head.getAttribute('aria-expanded') === 'true';
        var list = head.closest('.tp-faq__list');

        if (open) {
          closePanel(head, panel);
          return;
        }

        // accordion behaviour: one panel open at a time
        if (list && list.getAttribute('data-single') === 'true') {
          list.querySelectorAll('.tp-faq__head[aria-expanded="true"]').forEach(function (other) {
            var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
            if (otherPanel) closePanel(other, otherPanel);
          });
        }

        openPanel(head, panel);
      });
    });
  }

  function init(root) {
    var scope = root || document;
    initReveal(scope);
    initFaq(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var head = e.target.querySelector('.tp-faq__head');
    if (head && head.getAttribute('aria-expanded') === 'false') head.click();
  });
})();
